import { Directive, ElementRef, Input, OnInit, Renderer2, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { InputObservable } from '@y42/angular/util';
import { Observable, tap } from 'rxjs';

@UntilDestroy()
@Directive({
  selector: '[y42Emoji]',
})
export class EmojiDirective implements OnInit {
  constructor(
    private readonly el: ElementRef,
    private readonly sanitizer: DomSanitizer,
    private readonly renderer: Renderer2,
  ) {}

  @Input()
  @InputObservable()
  y42Emoji?: string;
  y42Emoji$!: Observable<string>;

  ngOnInit() {
    this.y42Emoji$
      .pipe(
        tap((emoji) => {
          if (!emoji) {
            this.renderer.setProperty(this.el.nativeElement, 'innerHTML', '');
            return;
          }

          this.sanitizer.sanitize(SecurityContext.HTML, emoji);
          this.renderer.setProperty(this.el.nativeElement, 'innerHTML', `&#x${emoji};`);
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
